const state = {
	userInfo: []
}
const getters = {
	getUserInfo() {
		return state.userInfo
	}
}
const mutations = {
	setUserInfo(state, userInfo) {
		state.userInfo = userInfo
	}
}

const actions = {
	setUserInfo({ commit }, userInfo) {
		commit('setUserInfo', userInfo)
	}
}

//调用方法
//getters调用： this.$store.getters['product/getProduct']
//actions调用： that.$store.dispatch('product/setProduct', pres.data)
//mutations调用： that.$store.commit('product/setProduct', pres.data)

export default{
	namespaced:true,
	state,
	getters,
	mutations,
	actions
}